const getOpenAppParams = (reportUuid = '', reporterName = '') => {
  let params = {
    shareType: 'reporterHomepage',
    id: reportUuid,
    needClipboard: false,
    address: window.location.href,
    openAppBigDataInfo: {
      origin: 7,
      sourceTag: 19,
      clickPosition: 36,
      itemId: reportUuid,
      weMediaId: reportUuid,
      url: window.location.href
    }
  }
  if(reporterName){
    params.title = '前往"' + reporterName + '"作品集主页'
  } else {
    let titleArr = document.title.split('-')
    params.title = '前往"' + titleArr[0] + '"作品集主页'
  }
  return params
}

export default getOpenAppParams